import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BASE = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error('Masukkan alamat email'); return; }
    setLoading(true);
    try {
      await axios.post(`${BASE}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch {
      toast.error('Terjadi kesalahan. Coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-white flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
                <CheckCircle2 size={32} className="text-green-600" />
              </div>
              <h1 className="text-xl font-bold text-slate-800">Email Terkirim!</h1>
              <p className="text-slate-500 text-sm leading-relaxed">
                Jika email <strong>{email}</strong> terdaftar, kamu akan menerima link reset password dalam beberapa menit.
                Cek folder spam jika tidak ada di inbox.
              </p>
              <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#0f6c44] font-semibold hover:underline">
                <ArrowLeft size={14} /> Kembali ke Login
              </Link>
            </div>
          ) : (
            <>
              <div className="mb-6">
                <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center mb-4">
                  <Mail size={22} className="text-[#0f6c44]" />
                </div>
                <h1 className="text-2xl font-bold text-slate-800 font-manrope">Lupa Password?</h1>
                <p className="text-slate-500 text-sm mt-1">Masukkan email akunmu dan kami akan kirimkan link reset password.</p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-xs font-semibold text-slate-600 block mb-1.5">Alamat Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="contoh@email.com"
                    data-testid="forgot-email-input"
                    className="w-full px-4 py-3 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-[#0f6c44] focus:ring-2 focus:ring-emerald-100 bg-slate-50"
                  />
                </div>
                <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                  className="w-full py-3 bg-[#0f6c44] text-white rounded-xl font-semibold text-sm hover:bg-[#0c5636] active:scale-95 transition-all disabled:opacity-60 flex items-center justify-center gap-2">
                  {loading ? <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : null}
                  {loading ? 'Mengirim...' : 'Kirim Link Reset'}
                </button>
                <div className="text-center">
                  <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700">
                    <ArrowLeft size={13} /> Kembali ke Login
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
